import React from "react";
import Svg, { Circle, Path, SvgProps } from "react-native-svg";

const FlashIcon = (props: SvgProps) => {
  return (
    <Svg width="48" height="48" fill="none">
      <Circle cx="24" cy="24" r="24" fill="#FFF3C2" />
      <Path
        fill="#8C6500"
        d="m32.05 23.762-10.5 11.25a.75.75 0 0 1-1.284-.657l1.374-6.874-5.403-2.029a.749.749 0 0 1-.281-1.219l10.5-11.25a.75.75 0 0 1 1.283.656l-1.378 6.883 5.403 2.026a.75.75 0 0 1 .281 1.214h.004Z"
      />
    </Svg>
  );
};

export default FlashIcon;
